
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.703 12l8.545-8.448a.902.902 0 000-1.286.927.927 0 00-1.3 0l-9.196 9.091a.904.904 0 000 1.286l9.196 9.09a.922.922 0 001.3 0 .902.902 0 000-1.285L8.703 12z","fill":"currentColor"}})])
          )
        }
      }
    